import {CustomNodeData, Port} from '../tabs/ReactFlowTab'
import {
    type Node,
} from '@xyflow/react';
import { v4 as uuidv4 } from 'uuid';

import { CreateSimulationRepresentation } from './CreateRepresentation';
import { LoadedModel } from '../tabs/ThreeDTab';
import { Model } from 'flexlayout-react/types/model/Model';

import { handleAddPlot } from './AddPlot';
import { handleAddTable } from './AddTable';
import { handleAddHeatMap } from './AddHeatMap';
import { handleAddHeatMapVideo } from './AddHeatMapVideo';
import { DocumentData } from '../../context/DocumentDataProvider';

/**
 * Creates the component node and loads the 3D component 
 *
 * @export
 * @param {string} componentText 
 * @param {React.Dispatch<React.SetStateAction<Node<CustomNodeData>[]>>} setNodes 
 */
export function CreateComponent(componentText:{ id: number; name: string ; content : string},
                                setNodes: React.Dispatch<React.SetStateAction<Node<CustomNodeData>[]>>,
                                setLoadedModels: React.Dispatch<React.SetStateAction<LoadedModel[]>>,
                                setPlots: React.Dispatch<React.SetStateAction<Map<string, any>>>,
                                layoutModel: Model,
                                setLayoutModel: React.Dispatch<React.SetStateAction<Model>>,
                                setDocumentData: React.Dispatch<React.SetStateAction<DocumentData>>,
                                setTables: React.Dispatch<React.SetStateAction<Map<string, any>>>,
                            ) {


    const componentData = JSON.parse(componentText.content);

    const uniqueId = `${componentData.type}-${Date.now()}-${Math.random().toString(36)}`;

    //newData?.custom_data?.object._Properties.representation_unique_id._Value
    

    console.log('Creating component with data:', componentData);
    const newNodeLabel = componentText.name || 'Component';


    const newNodeInputs = componentData.ports.inputs as Port[];
    const newNodeOutputs = componentData.ports.outputs as Port[];

    console.log("nodes", newNodeInputs, newNodeOutputs);

    let run_one_time = true;

    setNodes((nds) => {

                // If the component has a web_unique_id property, set it to the generated uniqueId
                if (componentData?.object?._Properties?.web_unique_id?._Value !== undefined ){
                    componentData.object._Properties.web_unique_id._Value = uniqueId;
                }

                const id = uuidv4();
                const newNode: Node<CustomNodeData> = {
                    id,
                    data:  {
                        label: newNodeLabel || `Node ${id}`,
                        inputs: newNodeInputs,
                        outputs: newNodeOutputs,
                        custom_data: componentData
                    },
                    position: { x: 100 + nds.length * 50, y: 100 },
                    type: 'custom',
                };
                if (run_one_time){
                    run_one_time = false;
                    console.log('Nodo agregado:', newNode);
                    console.log("-----------Tipo de componente:", componentData.type);
                    if (componentData?.object?._Properties?.representation_hash?._Value !== undefined ){
                        if (componentData.object._Properties.representation_unique_id._Value === ""){
                            componentData.object._Properties.representation_unique_id._Value = uniqueId;
                            CreateSimulationRepresentation(newNode.data, setLoadedModels);
                        }
                    }
                    console.log("-----------Tipo de componente: B", componentData.type);
                    switch (componentData.type) {
                        case "Simulador.Optics.BeamPropagation.Viewers.PerfectPowerMeter":
                            handleAddPlot(setDocumentData, setPlots, layoutModel, setLayoutModel, uniqueId, newNodeLabel);
                            break;
                        case "Simulador.SimuExtra.SimpleTable.TablePlotLineal":
                            handleAddPlot(setDocumentData, setPlots, layoutModel, setLayoutModel, uniqueId, newNodeLabel);
                            break;
                        case "Simulador.SimuExtra.SimpleTable.TablePlotHistogram":
                            handleAddPlot(setDocumentData, setPlots, layoutModel, setLayoutModel, uniqueId, newNodeLabel);
                            break;
                        case "Simulador.SimuExtra.SimpleTable.RepresentInTable":
                            handleAddTable(setDocumentData, setTables, layoutModel, setLayoutModel, uniqueId, newNodeLabel);
                            break;
                        case "Simulador.SimuExtra.SimpleTable.TablePlotHeatMap":
                            handleAddHeatMap(setDocumentData, setPlots, layoutModel, setLayoutModel, uniqueId, newNodeLabel);
                            break;
                        case "Simulador.SimuExtra.SimpleTable.RepresentHeadersInTable":
                            handleAddTable(setDocumentData, setTables, layoutModel, setLayoutModel, uniqueId, newNodeLabel);
                            break;
                        
                        case "Simulador.Optics.BeamPropagation.Components.InspectionPlaneField":
                            console.log("Agrega un heatmap video");
                            handleAddHeatMapVideo(setDocumentData, setTables, layoutModel, setLayoutModel, uniqueId, newNodeLabel);
                            
                            break;
                        default:
                            break;
                    }
                    
                }
                
                return [...nds, newNode];
            });
}